import { JSX } from 'react';
import { AdminMiniWorkspace } from '../admin-mini/components/AdminMiniWorkspace';
import { MYSTERY_SHOPPER } from '../admin-mini/admin-mini.descriptors';
import { CreateNewMysteryShopperModal } from './components/CreateNewMysteryShopperModal';

/**
 * The admin half of Mystery Shopper, on the Mini tab of a Nok Mini's edit screen.
 *
 * **The same screen the Compliance Sniffer renders** (user, 2026-09-11). It replaced a container
 * of this tool's own that drew its own run list, its own results panel and its own result modal -
 * the last of which led with three bordered boxes, two reading "Random Box 2" and "Random Box 3".
 * None of the three showed how a result had scored, which was the one thing the run exists to
 * produce.
 *
 * Everything here now comes from `admin-mini/`, so a change to how a run is listed or a result is
 * read reaches both tools at once.
 */
export const MysteryShopperContainer: () => JSX.Element = (): JSX.Element => (
    <AdminMiniWorkspace tool={ MYSTERY_SHOPPER }
                        blurb="Shops you started from HQ. A customer's own runs are not listed here."
                        createControl={ (): JSX.Element => <CreateNewMysteryShopperModal /> } />
);
